import { FC, memo, useCallback, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Button, Menu, MenuItem } from "@mui/material";
import { TConfigItemType } from "../../models";
import { FieldTypeChip } from "./FieldTypeChip";
import { ALL_QUESTIONNAIRE_FIELD_TYPES } from "./helpers";

export const AddFieldButton: FC<{
  onAdd: (type: TConfigItemType) => void;
}> = memo(({ onAdd }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handlePick = useCallback(
    (type: TConfigItemType) => {
      onAdd(type);
      setAnchorEl(null);
    },
    [onAdd],
  );

  return (
    <>
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={handleOpen}
        sx={{ alignSelf: "flex-start" }}
      >
        Add field
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {ALL_QUESTIONNAIRE_FIELD_TYPES.map((t) => (
          <MenuItem key={t} onClick={() => handlePick(t)} dense>
            <FieldTypeChip type={t} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});
